import React from "react";

const Divider = ({ className }) => {
  return <div className={`w-full h-[1px] ${className}`} />;
};

export default Divider;
